import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { SkeletonPage } from 'components/common';
import { useRecognitionGetAllQuery } from 'hooks';
import { useAppLocation } from 'hooks/helpers';
import { recognitionRoutes } from 'router/recognitionRoutes';
import { setDraftRecognition, useRecognitionStore } from 'store/recognition';
import { RecognitionView } from './RecognitionView';

export const RecognitionPage = () => {
  const { data, isLoading, isFetching } = useRecognitionGetAllQuery();
  const { isCreate, isNotFound } = useAppLocation(recognitionRoutes);
  const { recognitionId } = useParams<{ recognitionId: string }>();
  const { draft } = useRecognitionStore();

  useEffect(() => {
    if (!data?.length) return;

    if (recognitionId) {
      const active = data.find((rec) => rec.id === recognitionId);

      if (active) {
        setDraftRecognition(active);
      }
    }
  }, [recognitionId, data]);

  if (isLoading) {
    return <SkeletonPage />;
  }

  if (draft.id && !recognitionId && !isCreate && !isNotFound) {
    return <Navigate replace to={recognitionRoutes.recognitionId(draft.id)} />;
  }

  if (data?.length && !recognitionId && !isCreate && !isNotFound) {
    return (
      <Navigate replace to={recognitionRoutes.recognitionId(data[0].id)} />
    );
  }

  const isRecognitionPresent = data?.some(({ id }) => id === recognitionId);

  if (!isFetching && recognitionId && !isRecognitionPresent) {
    return <Navigate replace to={recognitionRoutes.notFound} />;
  }

  return <RecognitionView />;
};
